import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ExternalLink } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-dark-card border-t border-gray-800">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <Link to="/" data-discover="true" className="flex items-center space-x-2 mb-4">
              <img 
                src="/images/favicon.webp" 
                alt="Hexabet Connect" 
                className="w-6 h-6"
              />
              <span className="text-xl font-bold text-white">Hexabet Connect</span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed">
              Votre portail indépendant vers les meilleures plateformes de paris en ligne en France.
            </p>
            <p>Email : info@hexabetconnect.com</p>
            <p>Téléphone : +33 4 21 73 98 33</p>
            <p>Adresse : Paris, France</p>
          </div>











          <div className="space-y-3 text-sm font-semibold uppercase tracking-wide">
            <p className="text-xs font-medium uppercase tracking-[0.25em] text-accent">Navigation</p>
            <Link to="/" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-toxic-green">Accueil</Link>
            <Link to="/guides" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-toxic-green">Guides</Link>
            <Link to="/reviews" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-toxic-green">Avis</Link>
            <Link to="/news" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-toxic-green">Actualités</Link>
          </div>
          <div className="space-y-3 text-sm font-semibold uppercase tracking-wide">
            <p className="text-xs font-medium uppercase tracking-[0.25em] text-accent">Légal</p>
            <Link to="/privacy-policy" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-toxic-green">Politique de confidentialité</Link>
            <Link to="/terms" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-toxic-green">Conditions générales</Link>
            <Link to="/cookies" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-toxic-green">Politique cookies</Link>
            <Link to="/responsible-gaming" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-toxic-green">Jeu responsable</Link>
          </div>
          <div className="space-y-4 text-sm font-semibold uppercase tracking-wide">
            <p className="text-xs font-medium uppercase tracking-[0.25em] text-accent">Jeu responsable</p>
            <div className="grid grid-cols-2 gap-3">
              <a
                  href="https://www.anj.fr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center p-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition"
              >
                <img src="/images/logo-anj.svg" alt="ANJ - Autorité Nationale des Jeux" className="h-12 w-auto object-contain" loading="lazy" decoding="async" />
              </a>
              <a
                  href="https://www.evalujeu.fr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center p-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition"
              >
                <img src="/images/evalu.svg" alt="EvaluJeu" className="h-12 w-auto object-contain" loading="lazy" decoding="async" />
              </a>
              <a
                  href="https://www.sosjoueurs.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center p-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition"
              >
                <img src="/images/sos.svg" alt="SOS Joueurs" className="h-12 w-auto object-contain" loading="lazy" decoding="async" />
              </a>
              <a
                  href="https://www.sosjoueurs.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center p-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition"
              >
                <img src="/images/18+.svg" alt="18+" className="h-12 w-auto object-contain" loading="lazy" decoding="async" />
              </a>
            </div>
            </div>















        </div>

        {/* Disclaimer */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <p className="text-gray-400 text-xs leading-relaxed max-w-4xl">
            <strong className="text-gray-300">Avertissement :</strong> Hexabet Connect est un site indépendant de comparaison et d'analyse. Certains liens présents sur nos pages sont des liens d'affiliation, ce qui signifie que nous pouvons recevoir une commission si vous cliquez ou vous inscrivez via ces liens. Cela n'affecte jamais nos opinions, nos analyses ou nos évaluations. Réservé aux personnes de 18 ans et plus. Jouez de manière responsable - consultez Joueurs Info Service. Les conditions générales s'appliquent.
          </p>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-6 mt-6 text-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Hexabet Connect. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

